export default __webpack_public_path__ + "static/media/logo.bce373cc.jpg";